export const IconVacancy20: {
  name: 'icon_vacancy_20-a74040924740'
} = {
  name: 'icon_vacancy_20-a74040924740'
}
